import {Capacitor} from '@capacitor/core'
import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {isElectron} from '@toolify/client/src/modules/electron/singletons/isElectron'

export function useCurrentAppPlatform() {
  const isAppPlatformMobile = Capacitor.isNativePlatform()
  return {
    isAppPlatformMobile,
    currentAppPlatformType: isAppPlatformMobile ? AppPlatformType.Mobile : isElectron() ? AppPlatformType.Desktop : AppPlatformType.Web,
  }
}
